<template>
  <div class="select-wrap">

    <!-- Label -->
    <div v-if="label"
         class="label"
         :class="{ 'label-sm': size === 'sm' }">{{ label }}
    </div>
    <!-- /Label -->

    <!-- Select box -->
    <select :value=value
            @change="onChange"
            @input="onInput"
            class="custom-select"
            :class="{ 'custom-select-sm': size === 'sm' }">
      <slot></slot>
      <option v-for="(option, index) in options"
              :key="index"
              :value="option.value">{{ option.text }}
      </option>
    </select>
    <!-- /Select box -->

  </div>
</template>

<script>
export default {
  name: "EsgBaseSelectBox",
  props: {
    label: String,
    value: [String, Number],
    options: Array,
    size: String,
  },
  methods: {
    onInput($event) {
      this.$emit('input', $event.target.value);
    },
    onChange($event) {
      this.$emit('change', $event.target.value);
    },
  },
}
</script>

<style scoped>
.select-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-select {
  padding: 0.3rem 2.5rem 0.3rem .8rem;
  height: 2rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 8px) 5px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: NanumGothic, serif;
  color: #2E2E38;
  font-size: .875rem;
  font-weight: 400;
}

.custom-select:focus {
  border-color: unset;
  box-shadow: unset;
}

.custom-select + .label {
  font-size: .875rem;
  font-weight: 700;
}

.custom-select-sm {
  padding: 0.2rem 1.25rem 0.2rem .4rem;
  height: 1.6rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 3px) 6px;
  background-size: 12px 12px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: .75rem;
  font-weight: 400;
}

.label {
  font-size: .875rem;
  font-weight: 700;
  white-space: nowrap;
  margin-right: .5rem;
}

.label.label-sm {
  font-size: .75rem;
}
</style>